module.exports = __webpack_public_path__ + "static/running-1-d2e925916d224b420b6e762d9b199d0d.jpg";